import { render, staticRenderFns } from "./ModalSalesforce.vue?vue&type=template&id=4985111b&scoped=true"
import script from "./ModalSalesforce.vue?vue&type=script&lang=js"
export * from "./ModalSalesforce.vue?vue&type=script&lang=js"
import style0 from "./ModalSalesforce.vue?vue&type=style&index=0&id=4985111b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985111b",
  null
  
)

export default component.exports